<template>
  <section class="sonar-lab-session__container">
    <LabSession
      ref="labSession"
      :class="labLayoutExpanded && 'sonar-quiz__lab-iframe--expanded'"
      v-bind="{ parentId, parentType, labId, fetchLab }"
    />
  </section>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import CONSTANTS from '@/constants'
import LabSession from '@/components/lab/LabSession.vue'

export default {
  name: 'SonarLabSession',
  components: {
    LabSession,
  },
  props: {
    labLayoutExpanded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapState({
      currentLab: state => state.labs.currentLab,
      currentLabSession: state => state.labs.currentLabSession,
    }),
    ...mapGetters({
      currentQuestion: 'sonar/currentQuestion',
      assessmentAttempt: 'sonar/assessmentAttempt',
      isFetchingLab: 'labs/isFetchingLab',
      isChangingLabState: 'labs/isChangingLabState',
    }),
    isLabRunning() {
      return (
        this.currentLabSession?.status === CONSTANTS.LABS.SESSION_STATUS.STARTED
      )
    },
    parentType() {
      return CONSTANTS.PARENT_CONTENT_TYPES_KEYS.ASSESSMENT
    },
    parentId() {
      return this.assessmentAttempt?.id
    },
    labId() {
      return this.currentQuestion?.labData?.content_id
    },
    fetchLab() {
      if (this.isChangingLabState) return false
      const firstLabId = this.assessmentAttempt?.questionsLabData
        ?.firstLabQuestion?.content_id
      return (
        !this.currentLab?.id ||
        (!this.labId === firstLabId && firstLabId === this.currentLab?.id)
      )
    },
  },
  watch: {
    isFetchingLab(value) {
      if (value) {
        this.setCanAnswerQuestions(false)
        this.setIsAssessmentRunning(false)
      }
    },
  },
  methods: {
    ...mapActions('sonar', ['setCanAnswerQuestions', 'setIsAssessmentRunning']),
  },
}
</script>

<style lang="scss" scoped>
.sonar-lab-session {
  width: 100%;
  height: 100%;
  min-height: 280px;
  border-top: 1px solid var(--tundora-gray);

  &__wrapper {
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
  }
  &__container {
    width: 100%;
    height: 100%;
  }
}
</style>
